import type { OfferVM, FirmVM, ComparatorFilters } from "./types";
import { effectivePrice } from "./derive";

export function defaultFilters(): ComparatorFilters {
  return {
    search: "",
    firmSlugs: [],
    sizesK: [],
    accountTypes: [],
    drawdownTypes: [],
    platforms: [],
    dailyLoss: "all",
    ratingBand: "all",
    maxPrice: null,
    sortKey: "rating",
    sortDir: "desc",
  };
}

// Bands key off their lower edge so fractional ratings (rating is a Float) never
// fall between bands: high = [8, ∞), mid = [4, 8), low = (−∞, 4).
function ratingInBand(rating: number | null, band: ComparatorFilters["ratingBand"]): boolean {
  if (band === "all") return true;
  const r = rating ?? 0;
  if (band === "high") return r >= 8;
  if (band === "mid") return r >= 4 && r < 8;
  return r < 4; // low
}

export function applyFilters(
  offers: OfferVM[],
  firms: Map<string, FirmVM>,
  f: ComparatorFilters,
  now: Date = new Date(),
): OfferVM[] {
  const search = f.search.trim().toLowerCase();
  return offers.filter((o) => {
    const firm = firms.get(o.firmId);
    if (f.firmSlugs.length && (!firm || !f.firmSlugs.includes(firm.slug))) return false;
    if (f.sizesK.length && !f.sizesK.includes(o.accountSizeK)) return false;
    if (f.accountTypes.length && !f.accountTypes.includes(o.accountType)) return false;
    if (f.drawdownTypes.length && (!o.drawdownType || !f.drawdownTypes.includes(o.drawdownType))) return false;
    if (f.platforms.length && !o.platforms.some((p) => f.platforms.includes(p))) return false;
    if (f.dailyLoss === "none" && o.dailyLossUsd != null) return false;
    if (f.dailyLoss === "defined" && o.dailyLossUsd == null) return false;
    if (!ratingInBand(firm?.rating ?? null, f.ratingBand)) return false;
    if (f.maxPrice != null && effectivePrice(o, now) > f.maxPrice) return false;
    if (search) {
      const hay = `${firm?.name ?? ""} ${o.planName}`.toLowerCase();
      if (!hay.includes(search)) return false;
    }
    return true;
  });
}
